/**
 * @public
 * This keyCodes correspond to a key on the keyboard, including codes for special keys.
 * This codes work with the `keydown` event.
 *
 * @see
 * https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
 * https://api.jquery.com/keydown/#example-0
 */
const NOT_PRINTABLE_KEYS = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pause: 19,
  capsLock: 20,
  esc: 27,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  insert: 45,
  delete: 46,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numLock: 144,
  scrollLock: 145,
};

export default NOT_PRINTABLE_KEYS;
